import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { apiService } from '../../../../../service/api.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ResponseMedioVerificacionModel, MedioVerificacionModel} from '../../../../../model/Etapas.model'
import { ModalConfirmarEliminacionComponent } from '../modal-confirmar-eliminacion/modal-confirmar-eliminacion.component'
import { StorageService } from 'src/app/service/storage.service';
import Swal from 'sweetalert2';
import { JardinModel } from 'src/app/model/Jardin.model';
@Component({
  selector: 'app-modal-medios-verificacion',
  templateUrl: './modal-medios-verificacion.component.html',
  styleUrls: ['./modal-medios-verificacion.component.css']
})
export class ModalMediosVerificacionComponent implements OnInit {
  acordeon = false;
  cargando = true;
  archivoCargado = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('inputFile') inputArchivo: ElementRef;
  @ViewChild('divSpinnerModal') divSpinnerModal:ElementRef;
  displayedColumns=[];
  columnNames = [
    { id: 'nombre', value: 'nombreArchivo' },
    { id: 'acciones', value: 'acciones' }
  ];
  //dataSource : MatTableDataSource<MedioVerificacionModel>;
  dataSource : MedioVerificacionModel[];
  responseEquipoPedagogico = new ResponseMedioVerificacionModel();
  dataArchivo = new FormData();
  dataJardin = new JardinModel();
  constructor(
    public dialogRef: MatDialogRef<ModalConfirmarEliminacionComponent>,
    public api:apiService,
    public dialog: MatDialog,
    public storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.dataJardin = this.api.dataJardin;
    this.obtenerMediosVerificacion();
  }
  onNoClick(){
    this.dialogRef.close();
  }

  obtenerMediosVerificacion(){
    this.api.API_POST_obtenerMediosVerificacion(this.storageService.getCurrentUser().idUsuario).subscribe((response: ResponseMedioVerificacionModel) => {
      this.displayedColumns = this.columnNames.map(x => x.id);

      this.dataSource = response.payload

      this.cargando = false;
      this.divSpinnerModal.nativeElement.style.display='none';
    },
    (err) => {
      console.log(err)
    })
  }


  cambioArchivo(event){ 
    this.dataArchivo = new FormData();
    const extension = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf(".") + 1, event.target.files[0].name.length)
    const extensionesValidas = ["png","jpeg","jpg","gif","ppt","pptx","doc","docx","pdf"];
    const existeExtension = extensionesValidas.map(x=>x).indexOf(extension.toLowerCase());

    if(existeExtension == -1){
      Swal.fire({
        title: 'Error!',
        text: 'Ingrese un archivo valido',
        icon: 'error',
        confirmButtonText: 'OK'
      })
    }else{
      this.dataArchivo.append('nombre', event.target.files[0].name)
      this.dataArchivo.append('file', event.target.files[0])
      this.dataArchivo.append('idUsuario', this.storageService.getCurrentUser().idUsuario.toString())
      this.dataArchivo.append('idJardin', this.api.dataJardin.id.toString())
      this.archivoCargado = false;
    }
  }

  subirArchivo(event){
    this.divSpinnerModal.nativeElement.style.display='';
      this.inputArchivo.nativeElement.value = null;
        this.api.API_POST_guardarMediosVerificacion(this.dataArchivo).subscribe((response) => {
          this.obtenerMediosVerificacion();
          this.divSpinnerModal.nativeElement.style.display='none';
        },
        (err) => {
          Swal.fire({
            title: 'UPS!',
            text: 'El archivo supera el peso máximo (3 mb)',
            icon: 'error',
            confirmButtonText: 'OK'
          })
          console.log(err);
          this.divSpinnerModal.nativeElement.style.display='none';
      })
  }

  cancelarArchivo(){
    this.inputArchivo.nativeElement.value = null;
  }

  eliminarMedio(medio:MedioVerificacionModel){
    const dialogRef = this.dialog.open(ModalConfirmarEliminacionComponent, {
      disableClose: true ,
      data: {idMedioVerificacion: medio.idMedioVerificacion,  tipo: 'mediosVerificacion'}
    }); 

    dialogRef.afterClosed().subscribe(result => {
      
      if(result=='refresh'){
        this.cargando = true;
        this.obtenerMediosVerificacion();

      }
    });
    
  }

  descargarMedio(medio:MedioVerificacionModel){
    this.api.API_POST_descargarMediosVerificacion(medio.idMedioVerificacion).subscribe((response) => {
      var save = document.createElement('a');   
      save.href = "data:"+response.payload.mime+";base64,"+response.payload.base
      save.target = '_blank';
      save.download = response.payload.nombre || 'archivo.dat';
      var clicEvent = new MouseEvent('click', {
          'view': window,
              'bubbles': true,
              'cancelable': true
      });
      save.dispatchEvent(clicEvent);
      (window.URL || window.webkitURL).revokeObjectURL(save.href);
    },
    (err) => {
      console.log(err)
    })
  }
}
